import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

const config: SkyNetTableConfig = {
    tabs: [{
        name: 'Countries',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'countryName',
                reduced: true,
            },
            {
                name: 'countryIsoAlpha2Code',
                reduced: true,
            },
        ],
    }],
}

export default config
